export default __webpack_public_path__ + "static/betclic_studios-eb4893631fef7494f6be85e6f8b37669.jpg";